export const filterState = {
  heading: "",
  key: "",
  activityTitle: "",
  host: "",
  associatedEvent: "",
  organisation: "",
  location: "",
  description: "",
  contacts: [],
  is_private: true,
  sort: { column: "activityTitle", order: "desc" }
};